import { Observable } from 'rxjs';
import { APIResponseWrapper } from '../../models/common/api-response-wrapper';
import * as HrModels from '../hr.models';
import { Constructor, HrApiClient } from '../shared/hr-api-client';

export function withHrMigrationApi<TBase extends Constructor<HrApiClient>>(Base: TBase) {
  return class extends Base {
    refreshMigrationProposals(owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrMigrationRefreshResult>> {
        return this.http.post<APIResponseWrapper<HrModels.HrMigrationRefreshResult>>(`${this.baseUrl}/migration/refresh`, null, {
          params: this.params({ owningCompanyId })
        });
      }
    
    migrationProposals(owningCompanyId?: number, status?: string): Observable<APIResponseWrapper<HrModels.HrMigrationProposal[]>> {
        return this.http.get<APIResponseWrapper<HrModels.HrMigrationProposal[]>>(`${this.baseUrl}/migration/proposals`, {
          params: this.params({ owningCompanyId, status })
        });
      }
    
    approveMigrationProposal(proposalId: number, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrEmployee>> {
        return this.http.post<APIResponseWrapper<HrModels.HrEmployee>>(`${this.baseUrl}/migration/proposals/${proposalId}/approve`, null, {
          params: this.params({ owningCompanyId })
        });
      }
    
    dismissMigrationProposal(proposalId: number, reason?: string, owningCompanyId?: number): Observable<APIResponseWrapper<HrModels.HrMigrationProposal>> {
        return this.http.post<APIResponseWrapper<HrModels.HrMigrationProposal>>(`${this.baseUrl}/migration/proposals/${proposalId}/dismiss`, { reason }, {
          params: this.params({ owningCompanyId })
        });
      }
  };
}

